import * as React from "react"
const style = require("./main.styl")

interface Logo {
    src: string
}

interface Props {
    logos: Logo[]
}

interface State {
    row: number
}

export default class LogoWall extends React.PureComponent<Props, State> {
    constructor(prop) {
        super(prop)
        this.state = { row: 2 }
    }

    componentDidMount() {
        this.init()
        window.addEventListener("resize", this.init)
    }

    render() {
        return <div className={ style["logo-wall"] }>{this.renderRow()}</div>
    }
    renderRow() {
        let i: number
        const dom: JSX.Element[] = []
        for (i = 0; i < this.state.row; i++) {
            dom.push(
                <div key={ i } className="logo-wall-row">
                    {this.renderCell(i)}
                </div>
            )
        }
        return dom
    }
    renderCell(rowIndex: number) {
        const { logos } = this.props
        let i: number
        const dom: JSX.Element[] = []
        const colunm = logos.length / this.state.row
        for (i = 0; i < colunm; i++) {
            dom.push(
                <div key={ rowIndex * colunm + i } className="logo-wall-cell">
                    <div
                        className="logo-wall-cell-pic"
                        style={{
                            backgroundImage: `url(${
                                logos[rowIndex * colunm + i].src
                            })`
                        }}
                    />
                </div>
            )
        }
        return dom
    }
    init = () => {
        const windowWidth = document.body.clientWidth
        if (windowWidth < 430) {
            this.setState({ row: 6 }) // column: 2
        } else if (windowWidth < 578) {
            this.setState({ row: 4 }) // column: 3
        } else if (windowWidth < 769) {
            this.setState({ row: 3 }) // column: 4
        } else if (windowWidth < 1000) {
            this.setState({ row: 3 }) // column: 4
        } else {
            this.setState({ row: 2 }) // column: 6
        }
    }
}
